export const SET_OTP_OPTION = "SET_OTP_OPTION";
export const SET_EMAIL = "SET_EMAIL";